/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Legacy_Caption_AddressInputs */

const vi_carrier_legacy_caption_address = /** @type {(inputs: Carrier_Legacy_Caption_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Theo địa chỉ đã nhập`)
};

/**

* @param {Carrier_Legacy_Caption_AddressInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_legacy_caption_address = /** @type {((inputs?: Carrier_Legacy_Caption_AddressInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Legacy_Caption_AddressInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_legacy_caption_address(inputs)
});